import { render, staticRenderFns } from "./ShoppingListToggleButton.vue?vue&type=template&id=0f5cde07&scoped=true&"
import script from "./ShoppingListToggleButton.vue?vue&type=script&lang=js&"
export * from "./ShoppingListToggleButton.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingListToggleButton.vue?vue&type=style&index=0&id=0f5cde07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5cde07",
  null
  
)

export default component.exports